module.exports = __webpack_public_path__ + "img/2.f1b51241.png";